export const typedObjectEntries = <T extends Record<string, unknown>>(
  obj: T,
): Array<[keyof T, T[keyof T]]> => {
  return Object.entries(obj) as Array<[keyof T, T[keyof T]]>;
};

export const typedObjectKeys = <T extends Record<string, unknown>>(obj: T): Array<keyof T> => {
  return Object.keys(obj) as Array<keyof T>;
};
